export default {
  LESSON_PLAN_TITLE_REQUIRED: 'Lesson plan title is required',
  TIME_REQUIRED: 'Lesson plan title is required',
  LESSON_PLAN_COVER_IMAGE_REQUIRED: 'Lesson plan title is required',
  REQUIRED_FIELD: 'This is a required field'
};
